import { render, staticRenderFns } from "./AutomaticAntecipation.vue?vue&type=template&id=acafe994&scoped=true"
import script from "./AutomaticAntecipation.vue?vue&type=script&lang=js"
export * from "./AutomaticAntecipation.vue?vue&type=script&lang=js"
import style0 from "./AutomaticAntecipation.vue?vue&type=style&index=0&id=acafe994&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "acafe994",
  null
  
)

export default component.exports